import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=2e6fc6f2&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"
import style0 from "./AccountView.vue?vue&type=style&index=0&id=2e6fc6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6fc6f2",
  null
  
)

export default component.exports